import { AssistantNavigationTarget } from '../../../data-access';

// How a navigate target opens on web: a settings page section, or a core-action
// modal on the home page. Targets with no web destination map to undefined and
// are not rendered (the backend only knows the semantic target names).
export type NavigationTargetAction =
  | { kind: 'settings'; parentKey: string; hash?: string }
  | { kind: 'coreActionModal'; modal: 'daily_analysis' };

export const NAVIGATION_TARGET_ACTIONS: Record<
  AssistantNavigationTarget,
  NavigationTargetAction | undefined
> = {
  calendar_settings: { kind: 'settings', parentKey: 'calendars' },
  todo_integrations: { kind: 'settings', parentKey: 'todos' },
  health_settings: { kind: 'settings', parentKey: 'wearables' },
  daily_preview: { kind: 'coreActionModal', modal: 'daily_analysis' },
  // Web has no end-of-day summary screen yet.
  end_of_day_summary: undefined,
  ai_settings: { kind: 'settings', parentKey: 'aiAssistant' },
  subscription: { kind: 'settings', parentKey: 'subscription' },
  notification_settings: { kind: 'settings', parentKey: 'notifications' },
  energy_preferences: { kind: 'settings', parentKey: 'energyPreferences' },
  location_preferences: { kind: 'settings', parentKey: 'aiAssistant', hash: 'locationSettings' },
};
